export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            联系我们
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            有好的建议或想投稿资源？糖心影视期待你的声音
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 mb-10">
          <div className="text-center p-6 rounded-xl bg-background-100 border border-background-200/70">
            <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mx-auto mb-3">
              <i className="ri-mail-line text-xl"></i>
            </span>
            <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">投稿邮箱</h3>
            <p className="text-xs text-foreground-500">contact@tangxin.tv</p>
          </div>
          <div className="text-center p-6 rounded-xl bg-background-100 border border-background-200/70">
            <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mx-auto mb-3">
              <i className="ri-customer-service-line text-xl"></i>
            </span>
            <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">在线客服</h3>
            <p className="text-xs text-foreground-500">工作日 9:00-18:00</p>
          </div>
          <div className="text-center p-6 rounded-xl bg-background-100 border border-background-200/70">
            <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mx-auto mb-3">
              <i className="ri-feedback-line text-xl"></i>
            </span>
            <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">意见反馈</h3>
            <p className="text-xs text-foreground-500">feedback@tangxin.tv</p>
          </div>
        </div>

        <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
          <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-medium text-foreground-700 mb-1.5">你的昵称</label>
                <input
                  type="text"
                  name="name"
                  placeholder="请输入昵称"
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-all placeholder:text-foreground-400"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-700 mb-1.5">邮箱地址</label>
                <input
                  type="email"
                  name="email"
                  placeholder="请输入邮箱"
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-all placeholder:text-foreground-400"
                />
              </div>
            </div>
            <div>
              <label className="block text-xs font-medium text-foreground-700 mb-1.5">留言内容</label>
              <textarea
                name="message"
                rows={4}
                maxLength={500}
                placeholder="请输入你想说的话..."
                className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-all resize-none placeholder:text-foreground-400"
              ></textarea>
            </div>
            <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="honeypot-field" />
            <button
              type="submit"
              className="w-full sm:w-auto px-8 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              发送留言
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}